export const isEventDetailsEnabled = (sportId) => !!sportId && ['OB_SP42', 'OB_SP43'].includes(sportId);
//# sourceMappingURL=IsEventDetailsEnabled.js.map